export default "__VITE_ASSET__a3eb1dab__"